export default {
      id: "logo_css-usage",
      viewBox: "0 0 175 55",
      url: "../dist/images/" + "sprite.svg#logo_css-usage",
      toString: function () {
        return this.url;
      }
    }